// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__a51gt","menuItem--selected":"MenuItem_menuItem--selected__6ztJJ","icon":"MenuItem_icon__CmYFT"};